export default __webpack_public_path__ + "fa510f69184d2ef41cfa0a4c38505588.gif";